import { render } from "./KontynuujGre.vue?vue&type=template&id=26700c7e&scoped=true"
import script from "./KontynuujGre.vue?vue&type=script&lang=js"
export * from "./KontynuujGre.vue?vue&type=script&lang=js"

import "./KontynuujGre.vue?vue&type=style&index=0&id=26700c7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26700c7e"]])

export default __exports__